import {getIconById} from '../dataIcons'
import * as moment from 'moment'
import {useContext} from "react";
import {PointsContext} from "../../pages/MariupolPage";
import {Link, useNavigate, useOutletContext} from "react-router-dom";
import {LanguageContext} from "../../App";
import {format} from "date-fns";
import {isMobile} from "react-device-detect";

const SideBarLoading = () => {
    return (
        <>
            {[...Array(7)].map((el, index) =>
                <div key={index} className="border p-2 border-neutral-700 w-full mx-auto">
                    <div className="animate-pulse flex flex-col p-4 space-y-2">
                        <div className='flex justify-between'>
                            <div className="rounded-full bg-neutral-700 h-8 w-8"/>
                            <div className="h-4 bg-neutral-700 rounded w-20"/>
                        </div>
                        <div className="h-4 bg-neutral-700 rounded"/>
                        <div className="h-2 bg-neutral-700 rounded"/>
                        <div className='flex justify-between pt-2'>
                            <div className="h-4 bg-neutral-700 rounded w-20"/>
                            <div className="h-4 bg-neutral-700 rounded w-20"/>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}


const SideBar = () => {
    const {points} = useContext(PointsContext)
    const {language} = useContext(LanguageContext)

    const [clicked, setClicked, refs, setIsDetailed, range, pointsIsLoading] = useOutletContext();

    const detailedClick = async (e, point) => {
        e.preventDefault()
        await setClicked(point)
        setIsDetailed(true)
    }


    return (

        <section className={'flex flex-col overflow-y-scroll bg-neutral-800 z-20'} style={isMobile ? {height: '90%'} : {height: '95%'}}>
            {
                pointsIsLoading ?
                    <SideBarLoading/>
                    :
                    points.length ?
                        <>
                            {points.map((point) =>
                                // ref={refs[post.id]} key={post.id}
                                <article key={point.properties.id} ref={refs[point.properties.id]}
                                         className={'border-b border-neutral-700 bg-neutral-700 cursor-default p-4 border-neutral-700' + (clicked?.properties.id === point.properties.id ?
                                             'border-l-2 border-l-red-500' :
                                             'hover:bg-gray-50')}
                                         onClick={() => setClicked(point)}>
                                    <div className='flex justify-between text-sm text-gray-500'>
                                        <div className='flex items-center'>
                                            <img alt='Тип протеста' className='rounded-full bg-red-600 '
                                                 style={{height: '24px', width: '24px'}}
                                                 src={getIconById(point.properties.protest_type_id)}/>
                                            <p className='pl-2'>{point.properties.protest_type}</p>
                                        </div>
                                        <p className=''>{moment(point.properties.datetime).format('DD.MM H:mm')}</p>
                                    </div>

                                    <h1 className='text-sm py-3'>{point.properties.title}</h1>

                                    <div className='flex justify-between text-sm text-gray-500'>
                                        <a
                                            onClick={(e) => detailedClick(e, point)}
                                            href={(language.name === 'en') ? '/en/' + point.properties.slug || point.properties.id :
                                                '/' + point.properties.slug || point.properties.id}
                                            className='flex items-center hover:text-black hover:cursor-pointer'>
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="25px"
                                                 height="25px" viewBox="0 0 512.000000 512.000000">
                                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                                   fill="#000000" stroke="none">
                                                    <path
                                                        d="M3965 4160 c-16 -3 -39 -12 -50 -18 -11 -6 -318 -309 -682 -674 -589 -590 -663 -668 -673 -705 -19 -74 16 -155 80 -188 37 -19 123 -19 158 -1 34 18 1336 1322 1352 1355 17 33 15 112 -3 147 -34 66 -110 101 -182 84z"/>
                                                    <path
                                                        d="M1032 4140 c-18 -11 -41 -34 -52 -52 -20 -33 -20 -54 -20 -1528 0 -1474 0 -1495 20 -1528 11 -18 34 -41 52 -52 33 -20 54 -20 1528 -20 1474 0 1495 0 1528 20 18 11 41 34 52 52 19 32 20 52 20 808 0 756 -1 776 -20 808 -30 48 -75 72 -140 72 -65 0 -110 -24 -140 -72 -19 -32 -20 -52 -20 -700 l0 -668 -1280 0 -1280 0 0 1280 0 1280 668 0 c648 0 668 1 700 20 48 30 72 75 72 140 0 65 -24 110 -72 140 -32 19 -52 20 -808 20 -756 0 -776 -1 -808 -20z"/>
                                                </g>
                                            </svg>
                                            {language.main_page.side_bar.list.more}
                                        </a>
                                        {point.properties.url ?
                                            <a target='_blank' rel="noreferrer" href={point.properties.url}
                                               className='flex items-center justify-end hover:text-black hover:cursor-pointer'>
                                                {language.main_page.side_bar.list.url}
                                                <svg className='pl-1' xmlns="http://www.w3.org/2000/svg" width="22px"
                                                     height="22px" viewBox="0 0 100 100">
                                                    <path fill="#010101"
                                                          d="M82.686,53.754c-2.326,0-4.22,1.89-4.22,4.216v28.362c0,2.897-2.355,5.256-5.252,5.256H13.812   c-2.895,0-5.252-2.358-5.252-5.256V26.934c0-2.896,2.357-5.252,5.252-5.252h28.364c2.326,0,4.217-1.892,4.217-4.218   c0-2.324-1.892-4.216-4.217-4.216H13.812c-3.649,0-7.085,1.425-9.673,4.014c-2.587,2.587-4.014,6.022-4.014,9.672v59.398   c0,7.548,6.14,13.688,13.687,13.688h59.402c7.547,0,13.687-6.14,13.687-13.688V57.97C86.9,55.644,85.012,53.754,82.686,53.754z"/>
                                                    <path fill="#010101"
                                                          d="M86.275-0.07h-27.6c-2.318,0-4.202,1.885-4.202,4.203c0,2.317,1.884,4.203,4.202,4.203h26.896   l-48.38,48.375c-0.794,0.797-1.231,1.851-1.231,2.97c0,1.126,0.438,2.182,1.231,2.976c1.583,1.582,4.355,1.585,5.944,0   l48.376-48.377v26.89c0,2.317,1.882,4.201,4.2,4.201c2.317,0,4.202-1.884,4.202-4.201v-27.6C99.915,6.048,93.795-0.07,86.275-0.07z   "/>
                                                </svg>
                                            </a> : <span className='flex items-center '>{language.main_page.side_bar.list.no_url}</span>
                                        }
                                    </div>
                                </article>
                            )}
                            <div className='p-4 py-10 pb-16 text-gray-600 text-center'>
                                <p>
                                    {format(range.startDate, 'dd.MM.yy')} - {format(range.endDate, 'dd.MM.yy')}
                                </p>
                                {language.main_page.side_bar.sb_bottom2}
                            </div>
                        </>
                        :
                        <div className='p-4 py-10 text-center'>
                            {language.main_page.side_bar.sb_bottom}
                        </div>
            }


        </section>
    )
}

export default SideBar